export const BASE_URL = "https://touchdesign.in/api";

// export const BASE_URL = "http://localhost:5000";
// export const BASE_URL = "http://localhost:5000";
